var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[(_vm.title !== null)?_c('h4',{staticClass:"mb-1 heavy-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }